export enum UnitPaymentStatus {
  None = 0,
  Draft = 1,
  OtpSent = 2,
  OtpVerified = 3,
  Sent = 4,
}
